

















































































































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import VueTagsInput from '@johmun/vue-tags-input';
import { Getter } from 'vuex-class';
import CriteriaEditor from '@/components/CriteriaEditor.vue';
import TagSelector from '@/components/TagSelector.vue';
import PropertySelector from '@/components/PropertySelector.vue';
import * as $ from 'jquery';
import { Validations } from 'vuelidate-property-decorators';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { AudienceDetails } from '../models/AudienceDetails';
import { AudienceDetailsRequest } from '../models/AudienceDetailsRequest';
import AudienceGenericModal from '@/components/AudienceGenericModal.vue';
import BaseView from '../BaseView';
import StatisticsPanel from '@/components/StatisticsPanel.vue';
import Common from '../helper/Common';
import { StatisticsPanelModel } from '../models/StatisticsPanelModel';
import {
    GenericModal,
    GenericModalType,
    GenericModalCancelLabel,
    GenericModalContinueLabel,
    GenericModalTitle,
    GenericModalOption,
    GenericModalResponse
} from '../models/GenericModal';

const namespace: string = 'counter';
@Component({
    components: {
        VueTagsInput,
        CriteriaEditor,
        TagSelector,
        PropertySelector,
        AudienceGenericModal,
        StatisticsPanel
    },
})
export default class AudienceDetailsEditor extends BaseView {
    @Prop(AudienceDetails) public audienceDetails!: AudienceDetails;
    @Prop(AudienceDetails) public draftAudienceDetails!: AudienceDetails;

    // check if name has change and promp to confirm it it has changed.
    @Prop({ default: false }) public checkAudienceNameChanged!: boolean;

    // starting audience name, used to verify it it was changed when saving.
    @Prop({ default: '' }) public audienceName!: string;

    @Prop({ default: true }) public showCounts!: boolean;

    @Prop({ default: 0 }) public associatedCampaignsCount!: number;

    @Validations()
    private validations = {
        audienceDetails: {
            Name: {
                required,
                maxLength: maxLength(255)
            },
            Tags: {
            },
            Properties: {
                required
            },
            Description: {
                maxLength: maxLength(1000)
            },
            DynamicCriteria: {
            }
        }
    };

    private $v: any;
    private editingName: boolean = false;
    private criteriaJson: string = '';
    private isLoaded: boolean = false;
    private leftCriteriaMessage: string = 'If you close your Audience now, your changes will be lost.';
    private toggleSelectionToolTip: string = '';
    private canGenerateCounts: boolean = false;
    private statisticsRequestId: number = 0;
    private statisticsKey: number = 0;
    private totalRecords: number | null = null;
    private canViewCounts: boolean = true;
    private isGeneratingCounts: boolean = false;
    private criteriaEditorIsModified: boolean = false;
    private showEmDashAsCounts: boolean = false;
    // hack to fix defect #244346
    // https://cendyn.tpondemand.com/RestUI/Board.aspx#page=bug/244346
    private nameFieldSelectedBeforeCriteriaLoaded: boolean = false;

    private nameContainerWidth: number = 0;

    @Getter('currentClientId', { namespace })
    private clientId!: number;

    private showError: boolean = false;

    private isSaving: boolean = false;

    public onExitCriteriaPage() {
        const popup = new GenericModal();
        popup.id = 'LeaveCriteria';
        popup.cancelButton = GenericModalCancelLabel.StayOnPage;
        popup.continueButton = GenericModalContinueLabel.LeavePage;
        popup.title = GenericModalTitle.Unsavedchanges;
        popup.message = this.leftCriteriaMessage;
        this.showModal(popup);
    }

    public cleanEditor() {
        this.$v.$reset();
    }

    public blockSaving() {
        this.isSaving = true;
    }

    public unblockSaving() {
        this.isSaving = false;
    }

    public forceStatisticsGeneration(audienceDetailId: number) {
        this.checkStatisticsQuietly(true, audienceDetailId);
    }

    @Emit() private onSave(data: AudienceDetails) { return; }
    @Emit() private onSavePublish(data: AudienceDetails) { return; }

    private togglePropertySelected() {
        const pSelector: any = this.$refs.propertySelectorRef;
        pSelector.toggleSelection();
        this.toggleSelectionToolTip = pSelector.toggleSelectionToolTip();
        this.$v.audienceDetails.Properties.$touch();
    }

    private countsState(): string {
        if (!this.showCounts) {
            return '';
        }
        if ( this.criteriaEditorIsModified || this.$v.audienceDetails.Properties.$dirty) {
            return '';
        }

        if (this.isGeneratingCounts) {
            return 'generating';
        }

        if (this.isLoaded && this.canViewCounts) {
            return 'counts';
        }
        return '';
    }

    private save() {
        if (this.checkAudienceNameChanged && this.audienceDetails.Name !== this.audienceName) {
            this.saveNameConfirmationPopup();
        } else {
            const statisticsPanel: any = this.$refs.statisticsPanelRef;
            statisticsPanel.killStatistics();
            this.statisticsKey += 1;
            this.statisticsRequestId = -1;
            this.bubbleEvent('on-save');
        }
    }

    private saveAndPublish() {
        this.showError = true;
        if (this.$v.audienceDetails.$invalid) {
            this.validateName();
            return;
        } else {
            // TODO: change 1 to the actual number of campaings
            this.saveAndPublishPopup(this.associatedCampaignsCount);
        }
    }

    private saveConfirmed() {
        const statisticsPanel: any = this.$refs.statisticsPanelRef;
        statisticsPanel.killStatistics();
        this.isGeneratingCounts = false;
        this.statisticsKey += 1;
        this.statisticsRequestId = -1;
        this.bubbleEvent('on-save');
    }

    private saveAndPublishConfirmed() {
        const statisticsPanel: any = this.$refs.statisticsPanelRef;
        statisticsPanel.killStatistics();
        this.isGeneratingCounts = false;
        this.statisticsKey += 1;
        this.statisticsRequestId = -1;
        this.bubbleEvent('on-save-publish');
    }

    private bubbleEvent(eventName: string) {
        this.showError = true;
        if (this.$v.audienceDetails.$invalid) {
            this.validateName();
            return;
        }

        const self = this;
        const criteriaEditor: any = this.$refs.criteriaEditor as CriteriaEditor;
        criteriaEditor.getValue((dynamicCriteriaObj) => {
            // Set the Property Pool to the selected values
            dynamicCriteriaObj.propertyPool = self.audienceDetails.Properties.split(',');

            const formData: AudienceDetails = {
                Name: self.audienceDetails.Name,
                Description: self.audienceDetails.Description,
                DynamicCriteria: dynamicCriteriaObj,
                Tags: self.audienceDetails.Tags,
                Properties: self.audienceDetails.Properties,
                IsActive: self.audienceDetails.IsActive,
                AudienceID: self.audienceDetails.AudienceID,
                AudienceDetailsID: self.audienceDetails.AudienceDetailsID,
                IsReadOnly: false,
                AudienceDetailType: '',
                InsertDate: self.audienceDetails.InsertDate,
                UpdateDate: self.audienceDetails.UpdateDate,
                CountUnique: self.audienceDetails.CountUnique,
                CountTotal: self.audienceDetails.CountTotal,
                hasCount: false,
                IsGenerating: self.audienceDetails.IsGenerating,
                countsLastRunDate: self.audienceDetails.countsLastRunDate
            };

            console.log('AudienceDetailsEditor -> bubbleEvent', eventName, formData);

            this.$emit(eventName, formData);
            this.criteriaEditorIsModified = false;
            this.canViewCounts = true;

            if (eventName === 'on-save' || eventName === 'on-save-publish') {
                this.blockSaving();
                this.showEmDashAsCounts = true;
                this.totalRecords = null;
            }
        });
    }

    private saveNameConfirmationPopup() {
        const message = 'Changes to the Audience name will be applied to both the Saved & Published Audiences.';
        const popup = new GenericModal();
        popup.id = 'SaveAudienceNameConfirmation';
        popup.cancelButton = GenericModalCancelLabel.Cancel;
        popup.continueButton = GenericModalContinueLabel.Save;
        popup.title = GenericModalTitle.Confirm;
        popup.message = message;
        this.showModal(popup);
    }

    private saveAndPublishPopup(numOfCampaings: number) {
        const message = `Publishing your changes will affect ${numOfCampaings} campaign(s).`;
        const popup = new GenericModal();
        popup.id = 'SaveAndPublish';
        popup.cancelButton = GenericModalCancelLabel.Cancel;
        popup.continueButton = GenericModalContinueLabel.Publish;
        popup.title = GenericModalTitle.Confirm;
        popup.message = message;
        this.showModal(popup);
    }

    private showModal(request: GenericModal) {
        const modal: any = this.$refs.genericModalref;
        modal.show(request);
    }

    private hideModal() {
        const modal: any = this.$refs.genericModalref;
        modal.hide();
    }

    private handleContinuePopup(response: GenericModalResponse) {
        this.hideModal();
        switch (response.id) {
            case 'LeaveCriteria': {
                this.leaveCriteriaPage();
                break;
            }
            case 'SaveAndPublish': {
                this.saveAndPublishConfirmed();
                break;
            }
            case 'SaveAudienceNameConfirmation': {
                this.saveConfirmed();
                break;
            }
            default: {
                break;
            }
        }
    }

    private leaveCriteriaPage() {
        let returnURL = '/';
        if (this.$route.query.returnURL !== undefined) {
            returnURL = this.$route.query.returnURL.toString();
        }
        this.$router.push(returnURL);
    }

    private mounted() {
        console.log('AudienceDetailsEditor => mounted', this.audienceDetails);
        this.makeFullScreen();
        this.audienceName = this.audienceDetails.Name;
        const criteriaEditor: any = this.$refs.criteriaEditor as CriteriaEditor;
        criteriaEditor.setValue(this.audienceDetails.DynamicCriteria);
        const pSelector: any = this.$refs.propertySelectorRef;
        this.toggleSelectionToolTip = pSelector.toggleSelectionToolTip();

        // if (this.draftAudienceDetails && this.draftAudienceDetails.AudienceDetailsID !== this.audienceDetails.AudienceDetailsID) {
        //    if (JSON.stringify(this.draftAudienceDetails.DynamicCriteria) !== JSON.stringify(this.audienceDetails.DynamicCriteria)) {
        //        this.criteriaEditorIsModified = true;
        //    }
        // }

        this.updateTitleContainer();
        window.addEventListener('resize', this.updateTitleContainer);

        Vue.nextTick(() => this.checkStatisticsQuietly() );
    }

    private destroy() {
        window.removeEventListener('resize', this.updateTitleContainer);
    }

    private updateTitleContainer() {
        const containerWidth = $('#titleHeader').width();
        this.nameContainerWidth = containerWidth * 0.93;
    }

    private criteriaChanged(criteriaJson) {
        // debugger;
        this.criteriaJson = criteriaJson;
        this.criteriaEditorIsModified = true;
        this.canViewCounts = false;
        const statisticsPanel: any = this.$refs.statisticsPanelRef;
        statisticsPanel.killStatistics();
        this.statisticsKey += 1;
        this.statisticsRequestId = -1;
        this.isGeneratingCounts = false;
    }

    // private checkCriteriaModify(changed) {
    //    debugger;
    //    if (changed) {
    //        this.onExitCriteriaPage();
    //    } else {
    //        this.leaveCriteriaPage();
    //    }
    // }

    private blurName() {
        this.editingName = false;
    }

    private editName() {
        // hack to fix defect #244346
        if (!this.isLoaded) {
            this.nameFieldSelectedBeforeCriteriaLoaded = true;
        }
        this.editingName = true;

        this.$nextTick(() => {
            const nameInput: any = this.$refs.nameref;
            nameInput.focus();
        });
    }

    private validateName() {
        if (!this.$v.audienceDetails.Name.required) {
            this.dangerToastPopup('Audience Name is required.');
        } else if (!this.$v.audienceDetails.Name.maxLength) {
            this.dangerToastPopup('Audience name exceeds limit. Rename Audience to enable saving.');
        } else {
            this.editingName = !this.editingName;
        }
    }

    private close() {
        if (this.audienceDetails.IsReadOnly) {
            this.leaveCriteriaPage();
        } else if (this.$v.audienceDetails.$anyDirty) {
            this.onExitCriteriaPage();
        } else {
            if (this.criteriaEditorIsModified) {
                this.onExitCriteriaPage();
            } else {
                this.leaveCriteriaPage();
            }
        }
    }

    private updateLoadingStatus() {
        this.isLoaded = (this.$refs.criteriaEditor as any).isLoaded;

        // hack to fix defect #244346
        if (this.isLoaded && this.nameFieldSelectedBeforeCriteriaLoaded) {
            this.editingName = true;
            this.$nextTick(() => {
                const nameInput: any = this.$refs.nameref;
                nameInput.focus();
            });
        }
    }

    // #region Statistics Panel

    private openStatisticsPopOver() {
        const target: HTMLElement | null = document.getElementById('statisticsPanelLocation');
        const statisticsPanel: any = this.$refs.statisticsPanelRef;
        let requestId: number | null = this.statisticsRequestId;
        if (requestId < 0) {
            requestId = null;
        }
        const model: StatisticsPanelModel = new StatisticsPanelModel(
            this.clientId,
            // this.draftAudienceDetails.AudienceDetailsID,
            this.audienceDetails.AudienceDetailsID,
            target as HTMLElement,
            requestId);

        statisticsPanel.fetchStatistics(model);
    }

    // start panel quetly right away if on generating state.
    private checkStatisticsQuietly(forceRequest: boolean = false, audienceDetailId: number | null = null) {
        if (forceRequest) {
            this.isGeneratingCounts = true;
        }

        if (this.isGeneratingCounts === false) {
            return;
        }

        const detailId: number = audienceDetailId == null ?
            // this.draftAudienceDetails.AudienceDetailsID :
            this.audienceDetails.AudienceDetailsID :
            audienceDetailId;
        const target: HTMLElement | null = document.getElementById('statisticsPanelLocation');
        const statisticsPanel: any = this.$refs.statisticsPanelRef;
        const model: StatisticsPanelModel = new StatisticsPanelModel(
            this.clientId,
            detailId,
            target as HTMLElement,
            null,
            false,
            true,
            forceRequest);
        statisticsPanel.fetchStatistics(model);
    }

    private onStatisticsCompleted(data: any): void {
        if (this.statisticsRequestId !== 0 && this.statisticsRequestId !== data.reqiestId) {
            return;
        }
        this.totalRecords = data.totalCount;
        this.statisticsRequestId = -1;
        this.isGeneratingCounts = false;
        this.showEmDashAsCounts = false;
    }

    private onStatisticsGenerating(data: any): void {
        if (this.countsState() === '') {
            return;
        }
        this.statisticsRequestId = data.reqiestId;
        this.isGeneratingCounts = true;
    }

    private onStatisticsError(data: any): void {
        if (this.statisticsRequestId !== 0 && this.statisticsRequestId !== data.reqiestId) {
            return;
        }
        this.isGeneratingCounts = false;
        this.statisticsRequestId = -1;
    }
    private onStatisticsCancel(data: any): void {
        if (this.statisticsRequestId !== 0 && this.statisticsRequestId !== data.reqiestId) {
            return;
        }
        this.isGeneratingCounts = false;
        this.statisticsRequestId = -1;
    }

    private getTotalRecords() {
        // if (this.totalRecords != null) {
        //    // if counts are updated after initial load then totalRecords should not be null
        //    // and totalRecords should be used to show total records
        //    return Common.formatCounts(Number(this.totalRecords!));
        // }
        // else if (this.draftAudienceDetails.IsGenerating === true) {
        //    this.isGeneratingCounts = true;
        //    return 'Generating';
        // }
        // else if (
        //    this.draftAudienceDetails.hasCount === false ||
        //    this.draftAudienceDetails.CountTotal === null ||
        //    this.showEmDashAsCounts) {
        //    return '—';
        // }
        // return Common.formatCounts(Number(this.draftAudienceDetails.CountTotal!));
        if (this.totalRecords != null) {
            // if counts are updated after initial load then totalRecords should not be null
            // and totalRecords should be used to show total records
            return Common.formatCounts(Number(this.totalRecords!));
        } else if (this.audienceDetails.IsGenerating === true) {
            this.isGeneratingCounts = true;
            return 'Generating';
        } else if (
            this.audienceDetails.hasCount === false ||
            this.audienceDetails.CountTotal === null ||
            this.showEmDashAsCounts) {
            return '—';
        }
        return Common.formatCounts(Number(this.audienceDetails.CountTotal!));
    }

    // #endregion
}
